export default function WhyRaysSportsSection() {
  return (
    <section id="about" className="section-wrap bg-gradient-to-br from-gray-900 via-black to-gray-900">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-8">
            <span className="text-white">Why </span>
            <span className="text-green-400">Rays Sports</span>
          </h2>
          
          <div className="text-lg md:text-xl leading-relaxed text-gray-300 space-y-6">
            <p>
              Experience the future of sports management with <span className="text-green-400 font-semibold">Rays Sports Network</span>—your all-in-one, customizable SaaS platform built for sports organizations, academies, and institutions.
            </p>
            
            <p>
              Rays Sports brings together athletes, coaches, parents, teams, and venues into one integrated ecosystem, making engagement seamless and inspiring growth at every level. Our suite of products—<span className="text-green-400 font-semibold">Sync360</span> for holistic training management, <span className="text-green-400 font-semibold">Club7ms</span> for effortless team organization, and <span className="text-green-400 font-semibold">Rays Venue</span> for smart facility booking—empower you to streamline operations and foster community like never before.
            </p>
            
            <p>
              Unlock the power of white-label solutions designed to fit your organization, built on industry-leading technology, and ready to scale with your vision. Whether you're an academy looking to advance athlete performance or a club aiming to elevate participation, Rays Sports delivers a unified, flexible platform that sets you ahead of the game.
            </p>
            
            <div className="bg-gradient-to-r from-green-500/10 to-blue-500/10 rounded-2xl p-8 mt-8 border border-green-500/20">
              <p className="text-xl font-semibold text-white mb-4">
                Join the next generation of sports management.
              </p>
              <p className="text-lg text-green-400">
                Transform how you connect, train, and thrive—with Rays Sports.
              </p>
            </div>
          </div>
          
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 section-grid-gap">
            <div className="bg-gray-800/50 rounded-xl p-6 border border-gray-700">
              <div className="w-12 h-12 bg-green-500 rounded-lg flex items-center justify-center mb-4 mx-auto">
                <i className="ri-team-line text-xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Integrated Ecosystem</h3>
              <p className="text-gray-400 text-sm">Connect athletes, coaches, parents, teams, and venues in one unified platform</p>
            </div>
            
            <div className="bg-gray-800/50 rounded-xl p-6 border border-gray-700">
              <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center mb-4 mx-auto">
                <i className="ri-settings-3-line text-xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Customizable Solutions</h3>
              <p className="text-gray-400 text-sm">White-label platform that adapts to your organization's unique needs</p>
            </div>
            
            <div className="bg-gray-800/50 rounded-xl p-6 border border-gray-700">
              <div className="w-12 h-12 bg-purple-500 rounded-lg flex items-center justify-center mb-4 mx-auto">
                <i className="ri-rocket-line text-xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Scalable Technology</h3>
              <p className="text-gray-400 text-sm">Industry-leading platform built to grow with your vision and ambitions</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}